var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.032 1.46065C8.36926 0.603353 9.58809 0.619485 9.90253 1.48541L11.2738 5.26175C11.4109 5.63929 11.7606 5.89816 12.1617 5.91907L16.3974 6.13987C17.3127 6.18759 17.687 7.33887 16.9747 7.91565L13.8705 10.4295C13.5683 10.6742 13.4354 11.072 13.5297 11.4493L14.5622 15.5766C14.7828 16.4584 13.8078 17.1533 13.0462 16.6571L9.54589 14.3766C9.21407 14.1604 8.78593 14.1604 8.45411 14.3766L4.9538 16.6571C4.19223 17.1533 3.21722 16.4584 3.4378 15.5766L4.47027 11.4493C4.56465 11.072 4.43173 10.6742 4.1295 10.4295L1.0208 7.91202C0.309122 7.33569 0.682133 6.18535 1.59659 6.13632L5.6499 5.91899C6.04086 5.89802 6.38362 5.65084 6.52694 5.2865L8.032 1.46065Z",
    fill: "#FFB800",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStarFill);
export default __webpack_public_path__ + "static/media/ico-star-fill.cbb0c020ab3ca1a6ec827467f5518738.svg";
export { ForwardRef as ReactComponent };